import { type SaoDisplayStatus, type SaoPerCheckType } from '../api';

interface SaoDisplayStatusConfig {
    label: string;
    color: string;
    backgroundColor: string;
}

export const SAO_DISPLAY_STATUS_CONFIG: Record<SaoDisplayStatus, SaoDisplayStatusConfig> = {
    major_issues: { label: 'Major Issues', color: '#fff', backgroundColor: '#d32f2f' },
    major_issues_reviewed: { label: 'Major Issues (Reviewed)', color: '#fff', backgroundColor: '#2e7d32' },
    minor_issues: { label: 'Minor Issues', color: '#000', backgroundColor: '#fef3c7' },
    minor_issues_reviewed: { label: 'Minor Issues (Reviewed)', color: '#fff', backgroundColor: '#2e7d32' },
    likely_ok: { label: 'Likely OK', color: '#fff', backgroundColor: '#2e7d32' },
    processing: { label: 'Processing', color: '#666', backgroundColor: '#e0e0e0' },
    not_started: { label: '—', color: '#999', backgroundColor: 'transparent' },
    not_applicable: { label: 'N/A', color: '#999', backgroundColor: 'transparent' },
    // Labeled "Error" rather than "Failed" because users were reading "Failed" as a check result
    // (i.e. the student failed the plagiarism check) rather than a pipeline failure.
    failed: { label: 'Error', color: '#d32f2f', backgroundColor: '#ffebee' },
};

export const SAO_PER_CHECK_LABELS: Record<SaoPerCheckType, string> = {
    textual_plagiarism: 'Text',
    prior_similarity: 'Prior',
    ai_disclosure: 'AI',
};

/** Terminal positive statuses where the display should be grayed out */
const TERMINAL_POSITIVE_STATUSES = new Set(['no_issues', 'issues_detected_no_action_needed']);

export function isTerminalPositiveStatus(status: string): boolean {
    return TERMINAL_POSITIVE_STATUSES.has(status);
}
